import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicBrand({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M11.75 2.5c.28 0 .5.22.5.5v10.6a.5.5 0 01-.76.43l-3.23-1.98a.5.5 0 00-.52 0L4.5 14.03a.5.5 0 01-.76-.42V3c0-.28.22-.5.5-.5h7.5zM9.8 5H6.2a.5.5 0 00-.5.5v.4c0 .28.22.5.5.5h3.6a.5.5 0 00.5-.5v-.4a.5.5 0 00-.5-.5z"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgBasicBrand.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicBrand.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicBrand svgRef={ref} {...props} />);
export default ForwardRef;
